import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { FunctionCreateChecklistModalProps, createToastMessage, ToastMessage } from "../Interfaces/Interface"
const FunctionCreateChecklistModal: React.FC<FunctionCreateChecklistModalProps> = ({
  isOpen, onClose, newFunctionChecklistName, setNewFunctionChecklistName, newFunctionChecklistDescription, setNewFunctionChecklistDescription, onSave }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  if (!isOpen) return null;
  const handleSaveWithValidation = () => {
    if (!newFunctionChecklistName.trim() || !newFunctionChecklistDescription.trim()) {
      setMessage(createToastMessage("Please fill all fields", "warning", 3000));
      return;
    }
    if (newFunctionChecklistName.length > 60) {
      setMessage(createToastMessage("Checklist Name cannot exceed 60 characters", "warning", 3000));
      return;
    }
    onSave();
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Create Function Checklist</h3>
        <label>Function CheckList Name:
          <textarea value={newFunctionChecklistName} onChange={(e) => setNewFunctionChecklistName(e.target.value)} />
        </label>
        <label>Function Description:
          <textarea value={newFunctionChecklistDescription} onChange={(e) => setNewFunctionChecklistDescription(e.target.value)} />
        </label>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={handleSaveWithValidation}>Save</button>
        </div>
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default FunctionCreateChecklistModal;